export const enum MSG_EVENT {
  FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS',
  FILE_UPLOAD_FAIL = 'FILE_UPLOAD_FAIL',
  FILE_CLEAN = 'FILE_CLEAN',
  GO_AUTO_SUCCESS = 'GO_AUTO_SUCCESS',
  GO_AUTO_ZERO_CHART = 'GO_AUTO_ZERO_CHART',
  ADD_CHART_SUCCESS = 'ADD_CHART_SUCCESS',
  EXCEL_MULTIPLE_TAB = 'EXCEL_MULTIPLE_TAB',
  FILE_PROCESSING = 'FILE_PROCESSING',
  DATA_ANONYMIZED = 'DATA_ANONYMIZED',
  CHART_THEME_UPDATED = 'CHART_THEME_UPDATED',
  PROJECT_THEME_UPDATED = 'PROJECT_THEME_UPDATED',
  CHART_DOWNLOAD = 'CHART_DOWNLOAD',
  EMPTY_TRASH = 'EMPTY_TRASH',
  REPORT_GENERATION_INITIATED = 'REPORT_GENERATION_INITIATED',
  REPORT_GENERATION_COMPLETED = 'REPORT_GENERATION_COMPLETED',
  FEEDBACK_SUBMITTED = 'FEEDBACK_SUBMITTED',
  CLEANED_FILE_GENERATION_COMPLETED = 'CLEANED_FILE_GENERATION_COMPLETED',
  CLEANED_FILE_GENERATION_FAILED = 'CLEANED_FILE_GENERATION_FAILED',
  FIELD_CATEGORISATION_SUCCESS = 'FIELD_CATEGORISATION_SUCCESS',
  FIELD_CATEGORISATION_FAILED = 'FIELD_CATEGORISATION_FAILED',
  TIME_SERIES_DISABLED = 'TIME_SERIES_DISABLED',
  DASHBOARD_FILTER_SUCCESS = 'DASHBOARD_FILTER_SUCCESS',
  DASHBOARD_FILTER_REMOVED = 'DASHBOARD_FILTER_REMOVED',
  DASHBOARD_FILTER_FAILED = 'DASHBOARD_FILTER_FAILED',
  FILTERING_IN_PROGRESS = 'FILTERING_IN_PROGRESS',
  CHART_FILTER_APPLIED = 'CHART_FILTER_APPLIED',
  CHART_FILTER_REMOVED = 'CHART_FILTER_REMOVED',
  FILTERS_COPIED = 'FILTERS_COPIED',
  FILTER_DO_NOT_COPY = 'FILTERS_DO_NOT_COPY',
  FILE_COMBINE_SUCCESS = 'FILE_COMBINE_SUCCESS',
  FILE_COMBINE_CANCELLED = 'FILE_COMBINE_CANCELLED',
  ADD_FILE_FAIL = 'ADD_FILE_FAIL',
  FILE_COMBINE_STARTED = 'FILE_COMBINE_STARTED',
  FILE_COMBINE_UNSUCCESSFUL = 'FILE_COMBINE_UNSUCCESSFUL',
  FILE_COMBINE_FAIL = 'FILE_COMBINE_FAIL',
  FILE_ROW_COL_LIMITED = 'FILE_ROW_COL_LIMITED',
  LINK_SHARED_VIA_EMAIL = 'LINK_SHARED_VIA_EMAIL',
  API_INGESTION_LIMIT_EXCEEDED = 'API_INGESTION_LIMIT_EXCEEDED',
  API_RECALCULATION_LIMIT_EXCEEDED = 'API_RECALCULATION_LIMIT_EXCEEDED',
  DATA_RECALCULATION_COMPLETED = 'DATA_RECALCULATION_COMPLETED',
  INSIGHT_ADDED_AS_DESCRIPTION = 'INSIGHT_ADDED_AS_DESCRIPTION',
  CLOUD_UPDATE_COMPLETED = 'CLOUD_UPDATE_COMPLETED',
  PLAN_UPDATED = 'PLAN_UPDATED'
}

export const enum MSG_TYPE {
  SUCCESS = 'Success',
  ERROR = 'Error',
  INFO = 'Info',
  WARNING = 'Warning'
}

export interface NotificationData {
  id: string;
  is_read: boolean;
  is_silent: boolean;
  message_data: string;
  message_event: MSG_EVENT;
  message_text: string;
  message_type: MSG_TYPE;
  is_important: boolean;
  created_at: string;
  updated_at: string;
  recipient_obj: number;
  replaceKeyword?: string;
  linkKeyword?: string;
  isAnchorElement?: boolean;
  is_user_message?: boolean;
  feature_name?: string;
}

export interface NotificationRes {
  unreadMessages?: NotificationData[];
  allMessages?: NotificationData[];
  userMessages?: NotificationData[];
  storedUserMessages?: NotificationData[];
  isInitialLoad?: boolean;
}

export interface TransformedGetAllNotificationRes {
  allMessages?: NotificationData[];
  userMessages?: NotificationData[];
  storedUserMessages?: NotificationData[];
  isInitialLoad?: boolean;
}
export interface DirtFound {
  dirt_quantity: number;
  dirt_type: string;
}

export interface TransformedGetUnreadNotificationRes {
  unreadMessages?: NotificationData[];
  isInitialLoad?: boolean;
}

export interface MessageData {
  chart_id: string;
  project: Project;
  dirt_found: DirtFound[];
  chart_count?: number;
  url?: string;
  file_name?: string;
}

export interface Project {
  id: string;
  name: string;
}
